import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Breadcrumb from '../components/Breadcrumb';
import '../styles/Auditoria.css';

export default function Auditoria() {

    const [filtros, setFiltros] = useState({
        fechaInicio: '',
        fechaFin: '',
        usuario: ''
    });

    const [usuarios, setUsuarios] = useState([]);
    const [resultados, setResultados] = useState([]);
    const [loading, setLoading] = useState(false);

    /* cargar usuarios */
    useEffect(() => {
        axios.get('/api/auditoria/usuarios', {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        }).then(res => setUsuarios(res.data));
    }, []);

    /* valores por defecto: hoy */
    useEffect(() => {
        const hoy = new Date().toISOString().slice(0, 10);
        setFiltros(f => ({
            ...f,
            fechaInicio: hoy,
            fechaFin: hoy
        }));
    }, []);

    const handleBuscar = async () => {
        setLoading(true);
        try {
            const params = Object.fromEntries(
            Object.entries(filtros).filter(([_, v]) => v)
            );

            const res = await axios.get('/api/auditoria', {
            params,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });

            setResultados(res.data);
        } finally {
            setLoading(false);
        }
    };

    const exportarExcel = () => {
        const hoja = XLSX.utils.json_to_sheet(resultados);
        const libro = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(libro, hoja, 'Auditoría');
        const buffer = XLSX.write(libro, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([buffer]), 'auditoria.xlsx');
    };

    return (
        <>
            <div className="auditoria">
            <Breadcrumb />
            <h2>📋 Auditoría del sistema</h2>

            {/* Filtros */}
            <div className="filtros">
                <label>
                Fecha desde:
                <input
                    type="date"
                    value={filtros.fechaInicio}
                    onChange={e => setFiltros({ ...filtros, fechaInicio: e.target.value })}
                />
                </label>

                <label>
                Fecha hasta:
                <input
                    type="date"
                    value={filtros.fechaFin}
                    onChange={e => setFiltros({ ...filtros, fechaFin: e.target.value })}
                />
                </label>

                <select
                value={filtros.usuario}
                onChange={e => setFiltros({ ...filtros, usuario: e.target.value })}
                >
                <option value="">-- Usuario --</option>
                {usuarios.map(u => (
                    <option key={u} value={u}>{u}</option>
                ))}
                </select>

                <button onClick={handleBuscar}>🔍 Buscar</button>
            </div>

            {/* Acciones */}
            <div className="acciones">
                <button onClick={exportarExcel}>📤 Exportar a Excel</button>
            </div>

            {/* Spinner */}
            {loading && (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <div className="spinner"></div>
                <p>Cargando datos...</p>
                </div>
            )}

            {/* Tabla */}
            {!loading && (
                <table className="tabla-resultados">
                <thead>
                    <tr>
                    <th>Fecha</th>
                    <th>Usuario</th>
                    <th>Acción</th>
                    <th>Entidad</th>
                    <th>IP</th>
                    <th>Detalle</th>
                    </tr>
                </thead>
                <tbody>
                    {resultados.map((r, i) => (
                    <tr key={i}>
                        <td>{new Date(r.fecha).toLocaleString('es-ES')}</td>
                        <td>{r.usuario}</td>
                        <td>{r.accion}</td>
                        <td>{r.entidad}</td>
                        <td>{r.ipPublica}</td>
                        <td style={{ textAlign: 'left' }}>{r.detalle}</td>
                    </tr>
                    ))}
                </tbody>
                </table>
            )}
            </div>
        </>
    );
}
